module.exports = __webpack_public_path__ + "img/矩形 30 拷贝 2@2x(1).a83265aa.png";